import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { schedulePageRefresh } from "./utils/scheduler";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// Start the scheduler
schedulePageRefresh();

root.render(
  <>
    <App />
  </>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analyt
